import axios from "axios";

const url = process.env.REACT_APP_BASE_API_URL;

export const clientexsiteFindAllbyId = async (cliId) => {
  const headers = { "Content-Type": "application/json" };
  console.log("CliId", cliId);
  return await axios.get(url + `/v1/clientexsite/findbyid/${cliId}`, {
    headers,
  });
  //console.log(data);
};

export const clientexsiteDispEmUso = async (cliId) => {
  try {
    const headers = { "Content-Type": "application/json" };
    const data = await axios.get(
      url + `/v1/clientexsite/disponivelemuso/${cliId}`,
      {
        headers,
      }
    );
    return data;
  } catch (err) {
    console.log(err);
  }
};

export const clientexsiteDeleteCli = async (cliId) => {
  const headers = { "Content-Type": "application/json" };

  try {
    return await axios.delete(url + "/v1/clientexsite/delete/" + cliId, {
      headers,
    });
  } catch (err) {
    console.log(err);
  }
};

export const clientexsiteDelete = async (cliId, sitId) => {
  try {
    return await axios.delete(
      url + `/v1/clientexsite/delete/${cliId}/${sitId}`
    );
  } catch (err) {
    console.log("clixsiteDelete: " + err);
  }
};

export const clientexsiteInsert = async (body) => {
  const headers = { "Content-Type": "application/json" };
  return await axios.post(url + `/v1/clientexsite/insert`, body, {
    headers,
  });
};

export const clientexsiteUpdate = async (cliId, sitId, dtInicio, dtFim) => {
  if (!dtFim) {
    dtFim = "None";
  }
  return await axios.put(
    url + `/v1/clientexsite/update/${cliId}/${sitId}/${dtInicio}/${dtFim}`
  );
};
